import Vue from 'vue';
import Vuex from 'vuex';
import VueCookie from 'vue-cookie';
import './init';

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { StripePlugin } from '@vue-stripe/vue-stripe';

import eventBusService from '@/services/event-bus.service';
import { lsErrorService } from 'ls-vue-common';
import lsTrackService from '@/services/ls-track/ls-track.service';

import App from '@/App';
import store from '@/store';
import router from '@/router';
import screenSizeMixin from '@/mixins/initialization/screen-size';

import lsTrackDirective from '@/directives/ls-track/ls-track.directive';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_KEY,
        libraries: 'places',
    },
    installComponents: true,
});
Sentry.init({
    dsn: 'https://30bc3a221424493bb0209ed9a06409c0@o113786.ingest.sentry.io/1279909',
    integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
    environment: process.env.VUE_APP_ENVIRONMENT,
    release: process.env.VUE_APP_VERSION,
    ignoreErrors: ['An unexpected error has occured', 'NavigationDuplicated'],
});

// add brand tag
Sentry.setTag('brand', process.env.VUE_APP_BRAND);

lsTrackService.waitAndGetAnonymousId().then((segmentAnonId) => {
    lsErrorService.setUserContext({ segmentAnonId });
});

Vue.config.productionTip = false;

Vue.use(VueCookie);
Vue.use(StripePlugin, { pk: process.env.VUE_APP_STRIPE_KEY });

eventBusService.init();

Vue.mixin({
    computed: {
        ...Vuex.mapState(['screenSize']),
    },
});

Vue.directive('ls-track', lsTrackDirective);

new Vue({
    router,
    store,
    mixins: [screenSizeMixin],
    render: (h) => h(App),
}).$mount('#app');
